<template>
    <div>
        车辆换电列表
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>